import { render, staticRenderFns } from "./CABG1010.vue?vue&type=template&id=2a399690&scoped=true"
import script from "./CABG1010Controller.ts?vue&type=script&lang=ts&external"
export * from "./CABG1010Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CABG1010.vue?vue&type=style&index=0&id=2a399690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a399690",
  null
  
)

export default component.exports